import { render, staticRenderFns } from "./AFooterAddress.vue?vue&type=template&id=5132e362&scoped=true&functional=true&"
import script from "./AFooterAddress.vue?vue&type=script&lang=js&"
export * from "./AFooterAddress.vue?vue&type=script&lang=js&"
import style0 from "./AFooterAddress.vue?vue&type=style&index=0&id=5132e362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5132e362",
  null
  
)

export default component.exports